(function () {
  'use strict';
  if (window.__BTL_BUNDLE_IMAGES__) return;
  window.__BTL_BUNDLE_IMAGES__ = true;
  const cache = new Map();
  let sequence = 0;
  let restore = null;
  let navigating = false;
  const normalize = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const fieldName = select => normalize(select.name.match(/^properties\[(.*)\]$/)?.[1] || select.labels?.[0]?.textContent || select.id);

  function records() {
    try {
      const value = window.__SB_BUNDLED_VARIANTS__;
      const parsed = typeof value === 'string' ? JSON.parse(value) : value;
      return Array.isArray(parsed) ? parsed : [];
    } catch { return []; }
  }

  function resolve(select, container) {
    const name = fieldName(select);
    const values = new Map(Array.from(container.querySelectorAll('select'), field => [fieldName(field), normalize(field.value)]));
    const matches = records().filter(record => {
      const options = record.variant_options || [];
      return options.some(option => normalize(option.name) === name) &&
        options.every(option => values.get(normalize(option.name)) === normalize(option.value));
    });
    const unique = new Map(matches.map(record => [record.handle + ':' + record.variant_id, record]));
    return unique.size === 1 ? unique.values().next().value : null;
  }

  async function product(handle) {
    if (!cache.has(handle)) {
      const root = window.Shopify?.routes?.root || '/';
      cache.set(handle, fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(response => { if (!response.ok) throw new Error('Product unavailable (' + response.status + ')'); return response.json(); })
        .catch(error => { cache.delete(handle); throw error; }));
    }
    return cache.get(handle);
  }

  function imageKey(src, duplicated = false) {
    try {
      let path = new URL(src, location.href).pathname.replace(/_\d+x\d*(?=\.[^.]+$)/, '');
      if (duplicated) path = path.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\.[^.]+$)/i, '');
      return path;
    } catch { return ''; }
  }

  function sized(src, width) {
    const url = new URL(src, location.href);
    url.searchParams.set('width', width);
    return url.href;
  }

  function reset() {
    if (restore) { restore(); restore = null; }
  }

  function navigate(gallery, cell) {
    const id = cell.getAttribute('data-media-id');
    const thumbnail = Array.from(gallery.querySelectorAll('.product-gallery__thumbnail')).find(item => item.getAttribute('data-media-id') === id);
    if (thumbnail) {
      navigating = true;
      try { thumbnail.click(); } finally { navigating = false; }
    }
  }

  function show(select, src, details, width, height) {
    const section = select.closest('[data-section-type="product"]') || select.closest('.shopify-section') || document.querySelector('main');
    const gallery = section?.querySelector('.product-gallery');
    if (!gallery) throw new Error('Product gallery unavailable');
    reset();
    const cells = Array.from(gallery.querySelectorAll('.product-gallery__carousel-item[data-media-type="image"]'));
    const exact = cells.filter(cell => imageKey(cell.querySelector('img')?.src) === imageKey(src));
    const duplicates = exact.length ? exact : cells.filter(cell => imageKey(cell.querySelector('img')?.src, true) === imageKey(src, true));
    if (duplicates.length === 1) { navigate(gallery, duplicates[0]); return; }
    const cell = cells[0];
    const image = cell?.querySelector('.product-gallery__image');
    if (!image) throw new Error('Product gallery image unavailable');
    const attributes = Array.from(image.attributes, attribute => [attribute.name, attribute.value]);
    const ratio = image.closest('.aspect-ratio');
    const limiter = image.closest('.product-gallery__size-limiter');
    const ratioStyle = ratio?.getAttribute('style');
    const limiterStyle = limiter?.getAttribute('style');
    restore = () => {
      Array.from(image.attributes).forEach(attribute => image.removeAttribute(attribute.name));
      attributes.forEach(([name, value]) => image.setAttribute(name, value));
      for (const [element, style] of [[ratio, ratioStyle], [limiter, limiterStyle]]) {
        if (element) style === null ? element.removeAttribute('style') : element.setAttribute('style', style);
      }
    };
    image.removeAttribute('srcset');
    image.src = sized(src, 1400);
    image.alt = details;
    image.setAttribute('data-zoom', sized(src, 2000));
    image.setAttribute('data-zoom-width', width);
    image.width = width;
    image.height = height;
    if (ratio) ratio.style.paddingBottom = (height / width * 100) + '%';
    if (limiter) limiter.style.maxWidth = width + 'px';
    navigate(gallery, cell);
    window.dispatchEvent(new Event('resize'));
  }

  async function update(select) {
    const container = select.closest('#simple-bundles-io-options');
    if (!container) return;
    const token = ++sequence;
    const record = resolve(select, container);
    if (!record) { select.dataset.sbImageState = 'unmapped'; return; }
    select.dataset.sbImageState = 'loading';
    try {
      const data = await product(record.handle);
      const variant = data.variants?.find(item => String(item.id) === String(record.variant_id));
      if (!variant) throw new Error('Selected variant unavailable');
      const source = variant.featured_image?.src || data.featured_image || data.images?.[0];
      if (!source) throw new Error('Selected product has no image');
      const loaded = new Image();
      loaded.src = sized(source, 1400);
      await loaded.decode();
      if (token !== sequence || !select.isConnected) return;
      show(select, source, data.title + ' — ' + variant.title, loaded.naturalWidth, loaded.naturalHeight);
      select.dataset.sbImageState = 'ready';
      select.dataset.sbImageVariant = String(variant.id);
    } catch (error) {
      if (token === sequence) {
        select.dataset.sbImageState = 'unavailable';
        console.warn('[BTL bundle images]', record.handle, error.message);
      }
    }
  }

  for (const eventName of ['change', 'focusin']) {
    document.addEventListener(eventName, event => {
      if (event.target.matches?.('#simple-bundles-io-options select')) update(event.target);
    });
  }
  document.addEventListener('click', event => {
    if (!navigating && event.target.closest?.('.product-gallery__thumbnail')) { ++sequence; reset(); }
  }, true);
  document.addEventListener('shopify:section:unload', () => { ++sequence; reset(); });
})();
